import { Helmet } from 'react-helmet-async';
import { Container } from '@mui/material';
import CustomBreadcrumbs from '@/commons/custom-breadcrumbs';
import { PATH_DASHBOARD } from '@/routes/paths';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from '@/commons/snackbar';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postUsersService } from '@/services';
import { useAuthContext } from '@/hooks/useAuthContext';
import { translates } from '@/utils/translate';
import { TITLE } from '@utils/constants';
import { IUserAccountGeneral } from '../types';
import UserNewEditForm from '../form/user';

export default function UserCreatePage() {
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['users'],
    mutationFn: postUsersService,
    onSuccess: (data: IUserAccountGeneral) => {
      queryClient.setQueryData(['users', data?.id || ''], data);
      queryClient.invalidateQueries({ queryKey: ['users'] });
      enqueueSnackbar('Create success company!');
      navigate(PATH_DASHBOARD.users.list);
    },
    onError: (error: any) => {
      enqueueSnackbar(error, {
        variant: 'error',
      });
    },
  });

  const handleSubmit = async (dataForm: any) => {
    await mutateAsync({ ...dataForm, responsibleId: user?.id });
  };
  return (
    <>
      <Helmet>
        <title> {TITLE}: Crear un nuevo usuario </title>
      </Helmet>

      <Container maxWidth={false}>
        <CustomBreadcrumbs
          heading={`${translates.new} ${translates.user}`}
          links={[
            {
              name: translates.dashboard,
              href: PATH_DASHBOARD.root,
            },
            {
              name: translates.user,
              href: PATH_DASHBOARD.users.list,
            },
            { name: `${translates.new} ${translates.user}` },
          ]}
        />
        <UserNewEditForm onSave={handleSubmit} isLoading={isPending} />
      </Container>
    </>
  );
}
